// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CropController from "./crop_controller"
application.register("crop", CropController)

import DirectUploadsController from "./direct_uploads_controller"
application.register("direct-uploads", DirectUploadsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapController from "./map_controller"
application.register("map", MapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)

import PostRepliesController from "./post_replies_controller"
application.register("post-replies", PostRepliesController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ToggleContentController from "./toggle_content_controller"
application.register("toggle-content", ToggleContentController)

import ToggleThemeController from "./toggle_theme_controller"
application.register("toggle-theme", ToggleThemeController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
